import React from 'react';

const NotFound = () => {
  return <div>error 404</div>;
};

export default NotFound;
